import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vShow as _vShow, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "select-list" }
const _hoisted_3 = ["onUpdate:modelValue", "onChange"]
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "select-list" }
const _hoisted_6 = ["onUpdate:modelValue", "onChange"]
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "select-list" }
const _hoisted_9 = ["src", "alt", "onClick"]
const _hoisted_10 = { class: "tooltip" }
const _hoisted_11 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.elementList, (item) => {
            return (_openBlock(), _createElementBlock("li", { key: item }, [
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("input", {
                  class: "hidden",
                  type: "checkbox",
                  "onUpdate:modelValue": ($event: any) => ((_ctx.elementCheckList[item]) = $event),
                  onChange: ($event: any) => (_ctx.checkListOnChange(item, _ctx.elementCheckList))
                }, null, 40, _hoisted_3), [
                  [_vModelCheckbox, _ctx.elementCheckList[item]]
                ]),
                _createElementVNode("img", {
                  class: "filter",
                  src: _ctx.elementSrc(item),
                  alt: item
                }, null, 8, _hoisted_4)
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("ul", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weaponList, (item) => {
            return (_openBlock(), _createElementBlock("li", { key: item }, [
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("input", {
                  class: "hidden",
                  type: "checkbox",
                  "onUpdate:modelValue": ($event: any) => ((_ctx.weaponCheckList[item]) = $event),
                  onChange: ($event: any) => (_ctx.checkListOnChange(item, _ctx.weaponCheckList))
                }, null, 40, _hoisted_6), [
                  [_vModelCheckbox, _ctx.weaponCheckList[item]]
                ]),
                _createElementVNode("img", {
                  class: "filter",
                  src: _ctx.weaponSrc(item),
                  alt: item
                }, null, 8, _hoisted_7)
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("ul", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredList, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "with-tooltip",
              key: item.key
            }, [
              _createElementVNode("img", {
                class: _normalizeClass('character' + _ctx.bgImageClass(item) + _ctx.selectedClass(item)),
                src: item.icon_url,
                alt: item.key,
                onClick: ($event: any) => (_ctx.characterOnClick(item.key))
              }, null, 10, _hoisted_9),
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.displayName(item.key)), 1),
              _createElementVNode("img", {
                class: "vision",
                src: _ctx.visionSrc(item),
                alt: item.元素
              }, null, 8, _hoisted_11),
              _withDirectives(_createElementVNode("div", { class: "selection-number" }, _toDisplayString(_ctx.selectionNumber(item.key)), 513), [
                [_vShow, _ctx.selectionNumber(item.key)]
              ])
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}